import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import { format } from '~/util/date';

const text = {
  feedbackGivenLabel: 'Update gegeven op:',
};

type Props = {
  finalFeedbackGivenDate: string;
};

const FeedbackGiven: React.FCC<Props> = ({ finalFeedbackGivenDate }) => (
  <JustificationContainer align="center" gap="xxs" width="100%">
    <Body size="s" margin={[null]} color={{ group: 'primary' }}>
      {text.feedbackGivenLabel}
    </Body>
    <Body
      size="s"
      margin={[null]}
      fontWeight="semiBold"
      color={{ group: 'primary' }}
    >
      {format(finalFeedbackGivenDate, 'dd-MM-yyyy')}
    </Body>
  </JustificationContainer>
);

export default FeedbackGiven;
